import { combineReducers, configureStore } from "@reduxjs/toolkit";
import undoable from "redux-undo";
import appStateReducer from "./appStateSlice";
import structureReducer from "./structureSlice";
import selectionReducer from "./selectionSlice";
import bordersReducer from "./bordersSlice";
import cellStylesReducer from "./cellStylesSlice";
import spacerStylesReducer from "./spacerStylesSlice";
import templatesReducer from "./templatesSlice";
import styleSheetReducer from "./styleSheetSlice";
import preferencesReducer from "./preferencesSlice";
import joyrideReducer from "./joyrideSlice";
import { batchGroupBy } from "../helpers/batchGroupBy";

const undoRedoOptions = {
  //debug: true,
  ignoreInitialState: true,
  groupBy: batchGroupBy.init(),
};

const store = configureStore({
  reducer: {
    gridd: undoable(
      combineReducers({
        structure: structureReducer,
        borders: bordersReducer,
        cellStyles: cellStylesReducer,
        spacerStyles: spacerStylesReducer,
      }),
      undoRedoOptions
    ),
    selection: selectionReducer,
    app: appStateReducer,
    templates: templatesReducer,
    styleSheet: styleSheetReducer,
    preferences: preferencesReducer,
    joyride: joyrideReducer,
  },
});

export default store;
